import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from './theme/ThemeProvider';
import { ParticlesBackground } from './particles/ParticlesBackground';
import { AppRoutes } from './routes';
import { paletteForPath } from './lib/pagePaths';
import { initAnalytics, trackPageView } from './lib/analytics';

function BackgroundLayer() {
  const { pathname } = useLocation();
  return <ParticlesBackground palette={paletteForPath(pathname)} />;
}

function RouteAnalytics() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    initAnalytics();
  }, []);
  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);
  return null;
}

export function App() {
  return (
    <ThemeProvider>
      <BackgroundLayer />
      <AppRoutes />
      {/* After <AppRoutes/> so the page's useDocumentMeta effect sets the
          document title before the pageview is sent. */}
      <RouteAnalytics />
    </ThemeProvider>
  );
}
